// removed by extract-text-webpack-plugin
module.exports = {"story":"Newsletter__story--QIsxY","footer":"Newsletter__footer--Bg3hN","anchor":"Newsletter__anchor--1Rg08","bounce":"Newsletter__bounce--1Ht-p"};


//////////////////
// WEBPACK FOOTER
// ./src/subscriptions/components/Newsletter/Newsletter.css
// module id = ./src/subscriptions/components/Newsletter/Newsletter.css
// module chunks = 1